// Handle skip links in place so Blazor's router doesn't treat the fragment as a route change.
const SKIP_LINK_SELECTOR = 'a.cdphe-skip-link, a.skip-nav-link';

function handleSkipLinkClick(event: MouseEvent): void {
  const target = event.target as Element | null;
  const link = target?.closest(SKIP_LINK_SELECTOR) as HTMLAnchorElement | null;
  if (!link) return;

  const hash = link.hash || link.getAttribute('href') || '';
  if (!hash.startsWith('#') || hash.length < 2) return;

  const id = decodeURIComponent(hash.slice(1));
  const destination = document.getElementById(id);
  if (!destination) return;

  event.preventDefault();

  // Host pages may omit tabindex on the target.
  if (!destination.hasAttribute('tabindex')) {
    destination.setAttribute('tabindex', '-1');
  }
  destination.focus({ preventScroll: true });
  destination.scrollIntoView({ behavior: 'auto', block: 'start' });
}

if (typeof document !== 'undefined') {
  document.addEventListener('click', handleSkipLinkClick, true);
}
